<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <v-btn
          color="warning"
          class="mr-4"
          dark
          @click="$htmlToPaper('conferenceList')"
          >IMPRIMIR</v-btn
        >
      </v-card-title>
      <v-card-text>
        <div v-if="loader">CARREGANDO...</div>
        <All
          :data="dataReport"
          :filter="filter"
          :prefecture="prefecture"
          :provider="provider"
          ref="allComponent"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import All from "../impressions/conferencebillingsecretariart";
import helpers from "@/mixins/helpers";
export default {
  components: { All },
  props: {
    endDate: null,
    startDate: null,
    provider_id: null,
    prefecture_id: null,
    vehicle_id: null,
    sec_id: null,
  },
  mixins: [helpers],
  data: () => ({
    dataReport: [],
    filter: {},
    prefecture: [],
    provider: [],
    loader: false,
  }),
  created() {
    this.initialize();
    this.loadReport();
  },
  methods: {
    initialize() {
      this.helpers;
    },
    loadReport() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.filter.vehicle_id = this.vehicle_id;
      this.filter.provider_id = this.provider_id;
      this.filter.prefecture_id = this.prefecture_id;
      this.filter.startDate = this.startDate;
      this.filter.endDate = this.endDate;
      this.filter.sec_id = this.sec_id;
      this.$http
        .post(`/supplies/period/report/provider`, this.filter)
        .then((r) => {
          this.$http
            .get(`/prefectures/${this.filter.prefecture_id}`)
            .then((p) => {
              this.prefecture = p.data[0];
              this.$http
                .get(`/providers/${this.filter.provider_id}`)
                .then((pp) => {
                  this.provider = pp.data[0];
                  this.dataReport = r.data;
                  this.showPrintPageOne = true;

                  let resume = [];
                  let totalFinalLiters = 0;
                  let totalFinalValuesBilling = 0;
                  r.data.supplies.forEach((element) => {
                    totalFinalLiters += element.totalLiters;
                    totalFinalValuesBilling += element.totalValue;

                    const index = resume.findIndex(
                      (v) => v.item_id == element.item_id
                    );
                    if (index >= 0) {
                      resume[index].totalLiters += element.totalLiters;
                      resume[index].totalValue += element.totalValue;
                    } else {
                      resume.push({
                        item_id: element.item_id,
                        item_description_desc: element.item_description_desc,
                        totalLiters: element.totalLiters,
                        totalValue: element.totalValue,
                      });
                    }
                  });

                  this.dataReport.finalTotals.totalFinalLiters = totalFinalLiters;
                  this.dataReport.finalTotals.totalFinalValuesBilling = totalFinalValuesBilling;
                  this.dataReport.resume = resume;

                  // this.$refs.allComponent.initialize();
                  setTimeout(() => {
                    this.loader = false;
                    this.$store.dispatch("setLoader", this.loader);
                  }, 1000);
                });
            });
        });
    },
  },
};
</script>

<style></style>
